<template>
  <div class="main">
    <Header
      :show="true"
      title="字典"
      left="prepage"
      right="create"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="管理字典信息"
      />
      <el-table
        ref="table"
        :data="table.data"
        row-key="id"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{ row }">
            <div style="padding: 0 12px">
              <van-button
                size="small"
                style="margin-right: 10px"
                type="warning"
                @click="handleClickEditData(row)"
              >
                修改数据
              </van-button>
              <van-button
                size="small"
                style="margin-right: 10px"
                type="info"
                @click="handleClickUpdate(row)"
              >
                编辑类型
              </van-button>
              <van-button
                size="small"
                style="margin-right: 10px"
                type="danger"
                @click="handleClickDelete(row)"
              >
                删除字典
              </van-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="字典名称"
          prop="name"
          show-overflow-tooltip
          width="100"
        />
        <el-table-column
          label="类型编码"
          prop="type"
          show-overflow-tooltip
        />
      </el-table>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";
import { getList, deleteDict as deleteOne } from "@/api/dict.js";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      table: {
        listLoading: false,
        fullWidth: document.documentElement.clientWidth,
        key: 0,
        total: 0,
        data: [],
      },
      loading: false,
    };
  },
  created() {
    this.handleClickQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleClickRight() {
      this.$router.push({
        path: "/service/system/dict/create",
        query: {},
      });
    },
    handleTableRowClick(row, column, event) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickQuery() {
      const payload = { where: {} };
      getList(payload)
        .then((response) => {
          const { data } = response;
          if (
            showPhoneAlarm(
              false,
              "toast",
              null,
              2000,
              data.code,
              null,
              data.message
            )
          ) {
            this.table.total = data.data.length;
            this.table.data = data.data;
          }
        })
        .catch(function (error) {});
    },
    handleClickEditData(row) {
      this.$router.push({
        path: "/service/system/dictdata",
        query: {
          type: row.type,
        },
      });
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/system/dict/update",
        query: row,
      });
    },
    handleClickDelete(row) {
      Dialog.confirm({
        title: "确认删除此字典？",
      })
        .then(() => {
          this.loading = true;
          const data = row.id;
          deleteOne(data)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "删除",
                  data.message
                )
              ) {
                this.loading = false;
                this.handleClickQuery();
              }
            })
            .catch(function (error) {});
        })
        .catch(() => {
          showPhoneAlarm(true, "toast", null, 2000, 200, "删除", "取消");
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
// 自定义样式
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F7F8FA;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
